import React from "react";
import { Box, Button, Typography } from "@mui/material";

export interface BulkAction {
  label: string;
  onClick: () => void;
  color?:
    | "inherit"
    | "primary"
    | "secondary"
    | "success"
    | "error"
    | "info"
    | "warning";
}

interface BulkActionsBarProps {
  selectedCount: number;
  tableLabel: string;
  actions: BulkAction[];
}

export const BulkActionsBar: React.FC<BulkActionsBarProps> = ({
  selectedCount,
  tableLabel,
  actions,
}) => {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        width: "100%",
        px: 2,
        py: 1,
        backgroundColor: "#E8F0FE",
        fontFamily: "Roboto, sans-serif",
      }}
    >
      <Typography variant="subtitle1" sx={{ fontWeight: 500 }}>
        {selectedCount} {tableLabel}
        {selectedCount > 1 ? "s" : ""} selecionado
        {selectedCount > 1 ? "s" : ""}
      </Typography>
      <Box sx={{ display: "flex", gap: 2, marginRight:"2vw" }}>
        {actions.map((action, index) => (
          <Button
            key={index}
            variant="text"
            onClick={action.onClick}
            color={action.color || "primary"}
          >
            {action.label}
          </Button>
        ))}
      </Box>
    </Box>
  );
};
